module.exports = __webpack_public_path__ + "img/DE02793.e54c1326.png";